export const TABLE_HEAD =
  "border border-slate-300 p-4 px-1 bg-primary/90 text-white";
export const TABLE_ROW = "";
export const TABLE_DATA = "border border-slate-300 p-2 px-1";
